// src/pages/docs/custom/delete.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const HelpCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);
  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 770 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/도움말"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2}}>
          전적이에서 사용할 수 있는 모든 명령어들을<br />정리한 도움말입니다.
          </Typography>       
        </Box>
        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/help.png"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default HelpCommand;
